import { Group, Menu, UnstyledButton, Text } from "@mantine/core";
import { IconChevronDown, IconLanguage } from "@/lib/icons";
import { useTranslation } from "react-i18next";

const LANGS = [
  { code: "uz", label: "O'zbek", short: "UZ" },
  { code: "ru", label: "Русский", short: "RU" },
  { code: "en", label: "English", short: "EN" },
];

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = LANGS.find((l) => l.code === i18n.language) ?? LANGS[2];

  return (
    <Menu position="bottom-end" withArrow shadow="md" radius="md">
      <Menu.Target>
        <UnstyledButton
          px="sm"
          py={6}
          style={{
            borderRadius: 8,
            border: "1px solid var(--mantine-color-gray-2)",
            background: "white",
          }}
        >
          <Group gap={6} wrap="nowrap">
            <IconLanguage size={16} strokeWidth={1.6} />
            <Text size="sm" fw={600}>
              {current?.short}
            </Text>
            <IconChevronDown size={14} strokeWidth={1.6} />
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        {LANGS.map((l) => (
          <Menu.Item
            key={l.code}
            onClick={() => i18n.changeLanguage(l.code)}
            disabled={l.code === i18n.language}
          >
            <Group gap="sm">
              <Text size="sm" fw={600} c="dimmed" w={28}>
                {l.short}
              </Text>
              <Text size="sm">{l.label}</Text>
            </Group>
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
